import React, { useState } from 'react';
import { openAlert } from '../../utils/common';

const SortController = ({list, setList, selected, handleApply, handleReset }) => {
    const [moveCount, setMoveCount] = useState(1);
    const findIndex = id => list.findIndex(i => i.idx === id);
    const moveItem = (from, to) => {
        const a = [...list];
        const item = a.splice(from, 1)[0];
        a.splice(to, 0, item);
        setList(a);
    };

    const btnUp = () => {
        if (selected.length !== 1) {
        openAlert({ description: '게시글은 하나만 선택해주세요.' });
        return;
        }
        const from = findIndex(selected[0]);
        const to = Math.max(0, from - moveCount);
        moveItem(from, to);
    };

    const btnDown = () => {
        if (selected.length !== 1) {
        openAlert({ description: '게시글은 하나만 선택해주세요.' });
        return;
        }
        const from = findIndex(selected[0]);
        const to = Math.min(list.length - 1, from + moveCount);
        moveItem(from, to);
    };

    const btnTop = () => {
        if (selected.length !== 1) {
        openAlert({ description: '게시글은 하나만 선택해주세요.' });
        return;
        }
        const from = findIndex(selected[0]);
        moveItem(from, 0);
    };

    const btnEnd = () => {
        if (selected.length !== 1) {
        openAlert({ description: '게시글은 하나만 선택해주세요.' });
        return;
        }
        const from = findIndex(selected[0]);
        moveItem(from, list.length - 1);
    };
    
    return (
        <div className="col-md-1 ml-1">
          <div className="sort-control-container">
            <div className="body-box">
              <div className="mt2">
                <div className="insert mb-1">
                  <input className="input-32" type="number" value={moveCount} onChange={e => setMoveCount(Number(e.target.value) || 1)} />
                </div>
                <div className="insert"><span className="controller-btn"><img src={require('../../assets/img/control-top-max.png')} alt="" onClick={btnTop} />최상</span></div>
                <div className="insert"><span className="controller-btn"><img src={require('../../assets/img/control-top.png')} alt="" onClick={btnUp} />위</span></div>
                <div className="insert"><span className="controller-btn"><img src={require('../../assets/img/control-bt.png')} alt="" onClick={btnDown} />아래</span></div>
                <div className="insert"><span className="controller-btn"><img src={require('../../assets/img/control-bt-max.png')} alt="" onClick={btnEnd} />최하</span></div>
              </div>
            </div>
            <div className="sort-control-insert-wrap">
              <div className="insert insert-input-btn mt-1"><button className="btn-primary" onClick={handleApply}>적용하기</button></div>
              <div className="insert insert-input-btn mt-1"><button className="btn-default" onClick={handleReset}>초기화</button></div>
            </div>
          </div>
        </div>
    );
}

export default SortController;